import * as React from "react";
import MuiIconFa, { MuiIconFaProps } from "components/MuiExtras/MuiIconFa";
import { faAdjust } from "@fortawesome/pro-regular-svg-icons/faAdjust";
import { faCircle } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { faCircle as faCircleComplete } from "@fortawesome/pro-solid-svg-icons/faCircle";

interface IProps {
    progress: number;
}

const IconCompleted: React.FC<IProps & Omit<MuiIconFaProps, "icon">> = (props) => {
    const { progress, ...rest } = props;
    return <MuiIconFa {...rest}
        icon={
            progress == null || progress === 0
                ? faCircle
                : progress === 100
                    ? faCircleComplete
                    : faAdjust
        }
    />
}

export default IconCompleted
